module.exports = __webpack_public_path__ + "media/images/front/home_video_m-41866ef333eb7a68e2e75cbce674086c.mp4";